export default __webpack_public_path__ + "static/media/waves.c211ccb9.svg";